import { MDBCheckbox } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useState, useRef } from 'react';
import { externalNumberearch } from '../../../apiclients/streamsapi_bridge';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { validatePhoneNumber } from '../phonenumbers/AddRemoveNumbers';
import { normalizePhoneNumber } from '../../../apiclients/CommonUtils';

const AddExterNum = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [callerchecked, setCallerChecked] = useState(true);
    const typingTimerRef = useRef(null);
    const didSearchErrorRef = useRef("");

    const searchDID = async (number) => {
        try {
            if (props.setIsloading) props.setIsloading(true);
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const resp = await externalNumberearch(siteid, number);
            if (props.setIsloading) props.setIsloading(false);
            const data = await resp.json();
            const restrictMsg = "This is an internal number. Please provide an external number.";
            if (data.status === "success") {
                if (data.routing_obj) {
                        didSearchErrorRef.current = restrictMsg;
                        setError("uniqueid", { type: "server", message: restrictMsg });
                } else {
                    didSearchErrorRef.current = "";
                    clearErrors("uniqueid");
                }
            } else {
                const msgs = data?.message?.errors ?? [];
                if (msgs.length > 0) {
                    const errMsg = msgs[0].is_internal_did ? restrictMsg : msgs[0].message;
                    didSearchErrorRef.current = errMsg;
                    setError("uniqueid", { type: "server", message: errMsg });
                } else {
                    didSearchErrorRef.current = "";
                    clearErrors("uniqueid");
                }
            }
        } catch (err) {
            if (props.setIsloading) props.setIsloading(false);
            console.error("DID search error:", err);
        }
    };
    const { register, setValue, formState: { isDirty, errors, dirtyFields }, setError,clearErrors, handleSubmit, reset, getValues } = useForm({
        defaultValues: {
            name: "",
            uniqueid: "",
            cid_pass: "",
            cid_pass_flag: true,
        }
    });

    const onsubmit = async (data) => {
        //alert(JSON.stringify(data));
        props.setExternError([]);
        const modifiedData = {};
        if (isDirty) {

            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    modifiedData[field] = data[field];
                }
            }

            props.setExDetails(modifiedData);
            props.setExUpdate(true);
        }
    }

    useEffect(() => {
        //alert(JSON.stringify(externError));
        if (props.externError && props.externError.length > 0) {

            props.externError.forEach((err) => {
                let fieldName = "";
                if (err.param_name.toString().includes('.')) {
                    const splitArr = err.param_name.toString().split('.');
                    fieldName = splitArr[splitArr.length - 1];

                } else {
                    fieldName = err.param_name.toString();

                }
                setError(fieldName, {
                    type: "server",
                    message: err.message,
                });
            });
        }

    }, [props.externError]);

    useEffect(() => {
        return () => clearTimeout(typingTimerRef.current);
    }, []);

    return (
        <>
            <div className="pb-3 text-start">
                <div>
                    <div className="tel-numbers fw-bold">{t("name")}</div>
                </div>
                <div className="w-100">
                    <div className="w-100">
                        <input
                            type="text"
                            maxLength={30}
                            {...register("name", { required: "Name is required" })}
                            className="selectname w-100"
                        />
                        {errors.name && (
                            <p className="text-danger">{errors.name.message}</p>
                        )}
                    </div>
                </div>

                <div className="mt-2">
                    <div className="tel-numbers fw-bold">{t("Number")}</div>
                </div>
                <div className="w-100">
                    <div className="w-100">
                        <input
                            type="text"
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            {...register("uniqueid", {
                                // setValueAs: (value) => Number(value),
                                required: "Number is required",
                                validate: (value) => {
                                    if (didSearchErrorRef.current) return didSearchErrorRef.current;
                                    return validatePhoneNumber(value);
                                },
                                onChange: (e) => {
                                    normalizePhoneNumber(e);
                                    didSearchErrorRef.current = "";
                                    clearErrors("uniqueid");
                                    const digits = e.target.value.replace(/\D/g, "");
                                    if (props.enableDIDSearch && digits.length >= 10 && digits.length <= 11) {
                                        clearTimeout(typingTimerRef.current);
                                        typingTimerRef.current = setTimeout(() => {
                                            searchDID(digits);
                                        }, 500);
                                    }
                                }
                            })}
                            className="selectname w-100"
                        />
                        {errors.uniqueid && (
                            <p className="text-danger">{errors.uniqueid.message}</p>
                        )}
                    </div>
                </div>

                {props.calleridFlag && (
                    <>
                        <div className='mt-2 d-flex align-itemd-center justify-content-between w-100'>
                            <div className="tel-numbers fw-bold">{t("CallerIDpasstrough")}</div>
                            <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel' checked={getValues("cid_pass_flag")} onChange={(e) => {
                                setCallerChecked((obj) => !obj);
                                setValue("cid_pass_flag", e.target.checked, { shouldDirty: true });
                                if (e.target.checked) {
                                    clearErrors("cid_pass");
                                }
                            }} aria-label='...' />
                        </div>
                        <div className="phoneselect mt-2">
                            <select
                                className="form-control form-select selectname"
                                name="Default"
                                disabled={callerchecked}
                                {...register("cid_pass", {
                                    validate: (value)=>{
                                        const passFlag = getValues("cid_pass_flag");
                                        if (!passFlag && (!value || value === "")) return "Caller ID is required";
                                        if(value==="")return true;
                                        return validatePhoneNumber(value);
                                    }
                               
                            })}
                            >
                                <option value="">Choose Caller ID...</option>
                                {props.callerids && props.callerids.length > 0 && (props.callerids.map((item) => (
                                    <option value={item.phnum}>{item.addl_info}</option>
                                )))}

                            </select>
                            {errors.cid_pass && (
                                <p className="text-danger">{errors.cid_pass.message}</p>
                            )}
                        </div>
                    </>
                )}

            </div>
            {/* <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    data-mdb-dismiss="modal"
                    onClick={(e) => props.onClose(e)}
                >
                    {t('close')}
                </button>
                <button type="button" className="btn green-button" onClick={handleSubmit(onsubmit)}>
                    {t('add')}
                </button>
            </div> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={handleSubmit(onsubmit)}>
                    {t("add")}</button>
            </div>

        </>
    )
});

export default AddExterNum;